import { render, staticRenderFns, recyclableRender, components } from "./fight-group-detail.vue?vue&type=template&id=cd5345c4&"
var renderjs
import script from "./fight-group-detail.vue?vue&type=script&lang=js&"
export * from "./fight-group-detail.vue?vue&type=script&lang=js&"
import style0 from "./fight-group-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/plus/assemble/fight-group-detail/fight-group-detail.vue"
export default component.exports